import { Button, View } from "@/components/ui";
import { useWindowDimensions } from "@/components/hooks/use-window-dimension";
import { useRoute } from "@/components/shared/router";

export function AuthRemActionButtons() {
  const { push } = useRoute();
  const { isDesktop } = useWindowDimensions();

  return (
    <View className="flex shrink-0 flex-row items-center gap-2">
      {isDesktop && (
        <Button
          variant="secondary"
          color={"CTA2"}
          size="sm"
          rounded="full"
          onClick={() => push({ pageKey: "signup" })}
        >
          Sign Up
        </Button>
      )}
      <Button
        variant="primary"
        color={"CTA"}
        size="sm"
        rounded="full"
        onClick={() => push({ pageKey: "login" })}
      >
        Login
      </Button>
    </View>
  );
}
